/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Arrow from 'src/assets/arrow-left-black.svg';

import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  RegularButton,
  ICommonDropdownOption,
  FullScreenLoading,
} from 'pg-ui-library';
import {
  Container,
  ScreenHeader,
  CardContainer,
  CardHeader,
  LeftHeader,
  RightHeader,
  HelpForm,
  PageTitle,
  FormInputWrapper,
  NavTextLink,
  ArrowBack,
  HeaderItemLeft,
  ModuleLine,
} from './styles';
import { useFormik } from 'formik';
import { ISupportDesk } from 'src/interfaces';
import * as yup from 'yup';
import { levelOptions, supportDeskOptions, supportDeskSubmodules } from 'src/modules/personal-info';
import { useAddSupportTicket } from '../mutations/add-update-support.mutation';

const CreateTicket: React.FC = () => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState<ICommonDropdownOption[]>(
    supportDeskSubmodules[supportDeskOptions[0].value]
  );
  const addSupportTicket = useAddSupportTicket();
  const navigate = useNavigate();

  const validationSchema = yup.object({
    subject: yup.string().max(255).required('Subject is required'),
    description: yup.string().required('Description is required'),
    module: yup.string().required('Please select a module'),
    priority: yup.string().required('Please select a level'),
  });

  const formik = useFormik({
    initialValues: {
      module: supportDeskOptions[0].value,
      subCategory: subCategoryOptions[0].value,
      subject: '',
      description: '',
      priority: 'Normal',
      attachments: [],
    },
    validationSchema,
    onSubmit: async (values: ISupportDesk) => {
      try {
        const formData = new FormData();
        formData.append('module', values.module || '');
        formData.append('subCategory', values.subCategory || '');
        formData.append('subject', values.subject || '');
        formData.append('description', values.description || '');
        formData.append('priority', values.priority || '');
        formData.append('status', 'open');
        uploadedFiles.forEach(file => {
          formData.append('attachments', file);
        });
        await addSupportTicket.mutateAsync({ ticket: formData });
        navigate('/support-desk');
      } catch (error) {
        console.error('Error during submission of Ticket', error);
      }
    },
  });

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
    formik.setFieldValue('fileUpload', files);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    formik.setFieldValue('fileUpload', updatedFiles);
  };

  const handleModuleChange = (event: React.ChangeEvent<HTMLSelectElement> | string) => {
    let selectedModule: string;

    if (typeof event === 'string') {
      selectedModule = event;
    } else {
      selectedModule = event.target.value;
    }

    const newSubCategories = supportDeskSubmodules[selectedModule] || [];

    formik.setFieldValue('module', selectedModule);

    const defaultSubCategory = newSubCategories.length > 0 ? newSubCategories[0].value : '';
    formik.setFieldValue('subCategory', defaultSubCategory);

    setSubCategoryOptions(newSubCategories);
  };

  return (
    <Container>
      {addSupportTicket.isLoading && <FullScreenLoading />}
      <HeaderItemLeft>
        <NavTextLink to={-1 as any}>
          <ArrowBack src={Arrow} />
        </NavTextLink>
        <PageTitle>New Ticket</PageTitle>
      </HeaderItemLeft>
      <CardContainer>
        <HelpForm>
          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <CommonDropdown
                label="Please select the Module*"
                id="module"
                name="module"
                options={supportDeskOptions}
                value={formik.values.module}
                setValue={handleModuleChange}
                selectStyle={{
                  width: '100%',
                  height: '35px',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.module as string} visible={!!formik.errors.module} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonDropdown
                label="Sub Category*"
                id="subCategory"
                name="subCategory"
                options={subCategoryOptions}
                value={formik.values.subCategory}
                setValue={(value: string) => formik.setFieldValue('subCategory', value)}
                selectStyle={{
                  width: '100%',
                  height: '35px',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.subCategory as string} visible={!!formik.errors.subCategory} />
            </FormInputWrapper>
          </ModuleLine>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <CommonInput
              id="subject"
              name="subject"
              label="Subject*"
              placeholder="Enter your subject"
              value={formik.values.subject}
              onChange={event => formik.setFieldValue('subject', event.target.value)}
              style={{
                width: '100%',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
              }}
            />
            <FormErrorWrap errorMessage={formik.errors.subject as string} visible={!!formik.errors.subject} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <label htmlFor="description" style={{ display: 'block', marginBottom: '5px' }}>
              Description*
            </label>
            <textarea
              id="description"
              name="description"
              placeholder="Enter description"
              value={formik.values.description}
              onChange={event => formik.setFieldValue('description', event.target.value)}
              style={{
                width: '100%',
                height: '136px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                padding: '10px',
                resize: 'none',
                fontSize: '14px',
                textAlign: 'left',
                verticalAlign: 'top',
              }}
            />
            <FormErrorWrap
              errorMessage={formik.errors.description as string}
              visible={!!(formik.touched.description && formik.errors.description)}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <CommonDropdown
              label="Level of Priority*"
              id="Levels"
              name="Levels"
              options={levelOptions}
              value={formik.values.priority}
              setValue={(value: string) => formik.setFieldValue('priority', value)}
              selectStyle={{
                width: '100%',
                maxWidth: '100%',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
              }}
            />
            <FormErrorWrap errorMessage={formik.errors.priority as string} visible={!!formik.errors.priority} />
          </FormInputWrapper>
          {formik.values.priority && (
            <div style={{ marginTop: '10px', fontSize: '14px', color: '#4A4BA9' }}>
              {formik.values.priority === 'Normal' && <p>The team will get back to you soon.</p>}
              {formik.values.priority === 'Low' && <p>The team will get back to you as soon as possible.</p>}
              {formik.values.priority === 'High' && <p>The team will prioritize your request and respond shortly.</p>}
              {formik.values.priority === 'Urgent' && <p>Your request will be addressed with the highest priority.</p>}
            </div>
          )}

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '5px', position: 'relative' }}>
            <label
              htmlFor="fileUpload"
              style={{
                display: 'block',
                marginBottom: '5px',
                fontSize: '16px',
                color: '#222247',
              }}
            >
              Attachments
            </label>
            <input
              ref={fileInputRef}
              id="fileUpload"
              name="Attachment"
              type="file"
              style={{
                display: 'none',
              }}
              onChange={handleFileChange}
            />
            <div
              style={{
                width: '100%',
                height: '136px',
                border: '1px solid #ccc',
                borderRadius: '7px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative',
                marginBottom: '0px',
                boxSizing: 'border-box',
              }}
              onClick={handleFileUploadClick}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  font: '18px/27px Biotif',
                }}
              >
                <span
                  style={{
                    color: '#4A4BA9',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Add files
                </span>
                <span
                  style={{
                    color: '#222247',
                    opacity: 0.5,
                  }}
                >
                  Or drop files here
                </span>
              </div>
            </div>
            <FormErrorWrap errorMessage={formik.errors.attachments as string} visible={!!formik.errors.attachments} />
          </FormInputWrapper>
          <FormInputWrapper style={{ flex: '0 0 100%', marginTop: '0px' }}>
            <div
              style={{
                width: '55%',
                marginTop: '0px',
                paddingTop: '0px',
                borderRadius: '7px',
              }}
            >
              {uploadedFiles.map((file, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#4A4BA9',
                      textDecoration: 'none',
                      marginRight: '10px',
                      fontSize: '12px',
                    }}
                  >
                    {file?.name}
                  </a>
                  <span
                    onClick={() => handleRemoveFile(index)}
                    style={{
                      color: '#4A4BA9',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          </FormInputWrapper>

          <FormInputWrapper
            style={{ flex: '0 0 100%', display: 'flex', justifyContent: 'flex-start', marginBottom: '5px' }}
          >
            <RegularButton
              onClick={() => formik.handleSubmit()}
              disabled={!formik.isValid || formik.isSubmitting || addSupportTicket.isLoading}
            >
              Submit
            </RegularButton>
          </FormInputWrapper>
        </HelpForm>
      </CardContainer>
    </Container>
  );
};

export default CreateTicket;
